export default __webpack_public_path__ + "static/media/tomb.6ddc0240.svg";